var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.213,
    height: 22.223,
    viewBox: "0 0 22.213 22.223",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fb",
    transform: "translate(-1581 -6493.889)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M1094.777,226.67a8.889,8.889,0,1,0-8.893-8.888A8.893,8.893,0,0,0,1094.777,226.67Zm0,2.223a11.111,11.111,0,1,0-11.107-11.111A11.109,11.109,0,0,0,1094.777,228.893Z",
    transform: "translate(497.33 6287.219)",
    fill: "#1877f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M1093.11,214.17a1.107,1.107,0,0,1,1.107-1.111h1.12a1.111,1.111,0,0,0,0-2.223h-1.12a3.335,3.335,0,0,0-3.333,3.333v2.223h-1.107a1.111,1.111,0,0,0,0,2.223h1.107v6.667a1.119,1.119,0,0,0,1.12,1.111,1.107,1.107,0,0,0,1.107-1.111v-6.667h2.227a1.111,1.111,0,0,0,0-2.223h-2.227Z",
    transform: "translate(498.997 6288.607)",
    fill: "#1877f2"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.f23a8e5eba789e3ea4a89d0f9d247a5d.svg";
export { ForwardRef as ReactComponent };